import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
  selector: 'app-prime-select-button',
  templateUrl: './prime-select-button.component.html',
  styleUrls: ['./prime-select-button.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => PrimeSelectButtonComponent),
    multi: true,
  }],
  encapsulation: ViewEncapsulation.None
})
export class PrimeSelectButtonComponent implements ControlValueAccessor, OnInit {

  @Input() options: any;
  @Input() optionLabel: string = 'Title';
  @Input() dataKey: string = 'Id';
  @Input() multiple: boolean = false;
  @Input() styleClass: string = '';
  @Input() disabled: boolean = false;

  @Output() onSelectionChange = new EventEmitter<any>();

  public selectedItem = null;

  constructor() { }

  ngOnInit() { }

  onChange: any = () => { };
  onToched: any = () => { };

  public selectionChange(event) {
    this.onSelectionChange.emit(this.selectedItem);
    this.writeValue(this.selectedItem);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onToched = fn;
  }

  setDisabledState(isDisabled: boolean): void { }

  writeValue(value: any): void {
    this.selectedItem = value;
    this.onChange(value);
  }
}
